import store from '@/store/'
// eslint-disable-next-line no-unused-vars
export default function inviteTrafficManager({ from, next, router, to }) {
  const userType = store.getters['user/type']

  // redirect to dashboard if unauthorized
  if (userType && ['publisher'].indexOf(userType) < 0) {
    return router.push({ name: 'dashboard' })
  }

  // OR do nothing and go next
  return next()
}
